exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mailed-stack[data-v-e1408ebc] {\n    width: 1em;\n    height: 1em;\n    line-height: 1em;\n    vertical-align: 0%;\n}\n.mailed-icon[data-v-e1408ebc] {\n    font-size: 1em;\n}\n.mailed-badge[data-v-e1408ebc] {\n    font-size: .6em;\n    position: relative;\n    top: -12px;\n    left: 10px;\n}\n", ""]);

// exports
